import { getLightingFixtures, deleteFixture } from '@/services/floorPlanService';
import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { LightingFixture } from '@/types/floorPlanViewer';

export const fixtureServiceAdapter = {
  async getByFloorPlan(floorPlanId: string): Promise<LightingFixture[]> {
    const { data } = await getLightingFixtures(floorPlanId);
    return data || [];
  },

  async create(item: Partial<LightingFixture>): Promise<LightingFixture> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('lighting_fixtures')
      .insert(item as any)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, updates: Partial<LightingFixture>): Promise<LightingFixture> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('lighting_fixtures')
      .update(updates as any)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<boolean> {
    // deleteFixture also removes the fixture's circuit if it becomes empty,
    // so orphaned circuits don't linger in the Loads tab
    const { error } = await deleteFixture(id);

    if (error) throw error;
    return true;
  },
};
